<template>
  <v-text-field
    style="max-width: 400px"
    :value="value"
    @input="$emit('input', $event || null)"
    hide-details
    outlined
    flat
    :label="label"
    placeholder="Start typing to search..."
    prepend-inner-icon="search"
    clearable
  ></v-text-field>
</template>

<script>
export default {
  name: 'TableSearch',
  props: {
    value: { // v-model binding
      type: String
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>
